import React from "react";
import "./CallApp.css"; // Make sure the path is correct
import StatusBar from "../StatusBar/StatusBar";

export interface CallContent {
  Contact: string;
  date: string;
  time: string;
  type: "incoming" | "outgoing" | "missed";
}

interface CallsAppProps {
  callContent: CallContent[];
}

const CallApp: React.FC<CallsAppProps> = ({ callContent }) => {
  return (
    <div className={`call-app`}>
      <div className="app-status-bar">
        <StatusBar />
      </div>
      <>
        <div className="app-header">
          <div className="app-title">
            <h1>Recent Calls</h1>
          </div>
        </div>

        <div className="app-list">
          {callContent.map((call, index) => (
            <div key={index} className={`list-item ${call.type}`}>
              <div className="text-container">
                <div className="contact">{call.Contact}</div>
                <div className="type">{call.type}</div>
              </div>
              <div className="date-time-container">
                <div className="call-date">{call.date}</div>
                <div className="call-time ">{call.time}</div>
              </div>
            </div>
          ))}
        </div>
      </>
    </div>
  );
};

export default CallApp;
